import {
  Box,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Target, Layers, ScrollText } from 'lucide-react';
import { Trans } from '@lingui/react/macro';

function IncentiveProgramLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="112"
      height="128"
      viewBox="0 0 112 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.7901 3.98589C54.8661 3.36555 56.1918 3.36554 57.2678 3.98589L106.496 32.3672C107.572 32.9875 108.235 34.1339 108.235 35.3746V92.1372C108.235 93.3779 107.572 94.5243 106.496 95.1447L57.2678 123.526C56.1918 124.146 54.8661 124.146 53.7901 123.526L4.56196 95.1447C3.48596 94.5243 2.82312 93.3779 2.82312 92.1372V35.3746C2.82312 34.134 3.48596 32.9875 4.56196 32.3672L53.7901 3.98589Z"
        fill="url(#paint0_linear_116_38689)"
      />
      <path
        d="M55.5294 45.3997C60.5104 40.4188 64.628 38.7585 70.4723 38.7585C75.316 38.7585 79.9614 40.6827 83.3865 44.1077C86.8116 47.5328 88.7357 52.1782 88.7357 57.022C88.7357 64.6262 83.7216 70.4373 78.7738 75.2854L55.5294 98.5299L32.285 75.2854C27.304 70.4705 22.3231 64.6594 22.3231 57.022C22.3231 52.1782 24.2473 47.5328 27.6723 44.1077C31.0974 40.6827 35.7428 38.7585 40.5866 38.7585C46.4309 38.7585 50.5485 40.4188 55.5294 45.3997ZM55.5294 45.3997L45.7003 55.2288C45.0257 55.8986 44.4902 56.6953 44.1248 57.5729C43.7594 58.4506 43.5712 59.3919 43.5712 60.3426C43.5712 61.2933 43.7594 62.2346 44.1248 63.1122C44.4902 63.9899 45.0257 64.7866 45.7003 65.4564C48.4233 68.1793 52.7733 68.2789 55.6622 65.6888L62.536 59.3796C64.2589 57.8162 66.5021 56.9502 68.8286 56.9502C71.155 56.9502 73.3982 57.8162 75.1212 59.3796L84.9502 68.2125M75.4532 78.6061L68.812 71.9648M65.4913 88.568L58.8501 81.9267"
        stroke="url(#paint1_linear_116_38689)"
        stroke-width="5.14161"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.7906 3.98595C54.8666 3.36561 56.1923 3.36561 57.2683 3.98595L106.496 32.3672C107.572 32.9876 108.235 34.134 108.235 35.3747V92.1373C108.235 93.3779 107.572 94.5244 106.496 95.1447L57.2683 123.526C56.1923 124.146 54.8666 124.146 53.7906 123.526L4.56242 95.1447C3.48642 94.5244 2.82358 93.3779 2.82358 92.1373V35.3747C2.82358 34.134 3.48642 32.9876 4.56242 32.3672L53.7906 3.98595Z"
        stroke="url(#paint2_linear_116_38689)"
        stroke-width="5.14161"
      />
      <defs>
        <linearGradient
          id="paint0_linear_116_38689"
          x1="55.5291"
          y1="2.98337"
          x2="55.5291"
          y2="124.528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7865E0" />
          <stop offset="1" stop-color="#9A8CE8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_116_38689"
          x1="55.5294"
          y1="38.7585"
          x2="55.5294"
          y2="98.5299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FCFDFE" />
          <stop offset="1" stop-color="#EDF2F7" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_116_38689"
          x1="55.5294"
          y1="3.52069"
          x2="55.5294"
          y2="123.991"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FCFDFE" />
          <stop offset="1" stop-color="#EDF2F7" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function SilverTierLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="56"
      height="58"
      viewBox="0 0 56 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.2 1.31442C27.695 1.02861 28.305 1.02861 28.8 1.31442L51.4487 14.3907C51.9438 14.6765 52.2487 15.2047 52.2487 15.7763V41.9288C52.2487 42.5004 51.9438 43.0286 51.4487 43.3144L28.8 56.3907C28.305 56.6765 27.695 56.6765 27.2 56.3907L4.55129 43.3144C4.05625 43.0286 3.75129 42.5004 3.75129 41.9288V15.7763C3.75129 15.2047 4.05625 14.6765 4.55129 14.3907L27.2 1.31442Z"
        fill="url(#paint0_linear_2705_32544)"
        stroke="#4532AD"
        stroke-width="2.2"
      />
      <path
        d="M38.8052 34.1397C41.1052 31.8861 43.436 29.1849 43.436 25.6501C43.436 23.3985 42.5415 21.2391 40.9494 19.647C39.3573 18.0548 37.1979 17.1604 34.9463 17.1604C32.2296 17.1604 30.3156 17.9322 28.0002 20.2476C25.6848 17.9322 23.7708 17.1604 21.0541 17.1604C18.8025 17.1604 16.6431 18.0548 15.051 19.647C13.4589 21.2391 12.5645 23.3985 12.5645 25.6501C12.5645 29.2003 14.8798 31.9015 17.1952 34.1397L28.0002 44.9448L38.8052 34.1397Z"
        fill="#D2BE8F"
      />
      <path
        d="M38.8052 34.1397C41.1052 31.8861 43.436 29.1849 43.436 25.6501C43.436 23.3985 42.5415 21.2391 40.9494 19.647C39.3573 18.0548 37.1979 17.1604 34.9463 17.1604C32.2296 17.1604 30.3156 17.9322 28.0002 20.2476C25.6848 17.9322 23.7708 17.1604 21.0541 17.1604C18.8025 17.1604 16.6431 18.0548 15.051 19.647C13.4589 21.2391 12.5645 23.3985 12.5645 25.6501C12.5645 29.2003 14.8798 31.9015 17.1952 34.1397L28.0002 44.9448L38.8052 34.1397Z"
        fill="#CBCBCB"
      />
      <path
        d="M28.0002 20.2476L23.4312 24.8165C23.1176 25.1279 22.8687 25.4982 22.6988 25.9062C22.529 26.3142 22.4415 26.7517 22.4415 27.1936C22.4415 27.6356 22.529 28.0731 22.6988 28.4811C22.8687 28.8891 23.1176 29.2594 23.4312 29.5707C24.697 30.8365 26.719 30.8828 28.062 29.6788L31.2572 26.746C32.058 26.0193 33.1008 25.6167 34.1822 25.6167C35.2637 25.6167 36.3064 26.0193 37.1073 26.746L41.6763 30.8519"
        fill="#D2BE8F"
      />
      <path
        d="M28.0002 20.2476L23.4312 24.8165C23.1176 25.1279 22.8687 25.4982 22.6988 25.9062C22.529 26.3142 22.4415 26.7517 22.4415 27.1936C22.4415 27.6356 22.529 28.0731 22.6988 28.4811C22.8687 28.8891 23.1176 29.2594 23.4312 29.5707C24.697 30.8365 26.719 30.8828 28.062 29.6788L31.2572 26.746C32.058 26.0193 33.1008 25.6167 34.1822 25.6167C35.2637 25.6167 36.3064 26.0193 37.1073 26.746L41.6763 30.8519"
        fill="#CBCBCB"
      />
      <path d="M37.2617 35.6833L34.1745 32.5962L37.2617 35.6833Z" fill="#D2BE8F" />
      <path d="M37.2617 35.6833L34.1745 32.5962L37.2617 35.6833Z" fill="#CBCBCB" />
      <path d="M32.6309 40.314L29.5438 37.2269L32.6309 40.314Z" fill="#D2BE8F" />
      <path d="M32.6309 40.314L29.5438 37.2269L32.6309 40.314Z" fill="#CBCBCB" />
      <path
        d="M28.0002 20.2476C30.3156 17.9322 32.2296 17.1604 34.9463 17.1604C37.1979 17.1604 39.3573 18.0548 40.9494 19.647C42.5415 21.2391 43.436 23.3985 43.436 25.6501C43.436 29.1849 41.1052 31.8861 38.8052 34.1397L28.0002 44.9448L17.1952 34.1397C14.8798 31.9015 12.5645 29.2003 12.5645 25.6501C12.5645 23.3985 13.4589 21.2391 15.051 19.647C16.6431 18.0548 18.8025 17.1604 21.0541 17.1604C23.7708 17.1604 25.6848 17.9322 28.0002 20.2476ZM28.0002 20.2476L23.4312 24.8165C23.1176 25.1279 22.8687 25.4982 22.6988 25.9062C22.529 26.3142 22.4415 26.7517 22.4415 27.1936C22.4415 27.6356 22.529 28.0731 22.6988 28.4811C22.8687 28.8891 23.1176 29.2594 23.4312 29.5707C24.697 30.8365 26.719 30.8828 28.062 29.6788L31.2572 26.746C32.058 26.0193 33.1008 25.6167 34.1822 25.6167C35.2637 25.6167 36.3064 26.0193 37.1073 26.746L41.6763 30.8519M37.2617 35.6833L34.1745 32.5962M32.6309 40.314L29.5438 37.2269"
        stroke="#4532AD"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2705_32544"
          x1="28"
          y1="0.852539"
          x2="28"
          y2="56.8525"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7865E0" />
          <stop offset="1" stop-color="#9A8CE8" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function PlatinumTierLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_2705_32564)">
        <path
          d="M27.5479 1.20728C27.7953 1.06441 28.1002 1.06448 28.3477 1.20728L50.9971 14.2834C51.2443 14.4263 51.3963 14.6903 51.3965 14.9758V41.1292C51.3963 41.4147 51.2443 41.6786 50.9971 41.8215L28.3477 54.8977C28.1002 55.0405 27.7953 55.0406 27.5479 54.8977L4.89941 41.8215C4.65201 41.6787 4.49916 41.4148 4.49902 41.1292V14.9758C4.49919 14.6902 4.65203 14.4263 4.89941 14.2834L27.5479 1.20728Z"
          fill="url(#paint0_linear_2705_32564)"
        />
        <path
          d="M27.5479 1.20728C27.7953 1.06441 28.1002 1.06448 28.3477 1.20728L50.9971 14.2834C51.2443 14.4263 51.3963 14.6903 51.3965 14.9758V41.1292C51.3963 41.4147 51.2443 41.6786 50.9971 41.8215L28.3477 54.8977C28.1002 55.0405 27.7953 55.0406 27.5479 54.8977L4.89941 41.8215C4.65201 41.6787 4.49916 41.4148 4.49902 41.1292V14.9758C4.49919 14.6902 4.65203 14.4263 4.89941 14.2834L27.5479 1.20728Z"
          fill="#4A5568"
        />
        <path
          d="M27.5479 1.20728C27.7953 1.06441 28.1002 1.06448 28.3477 1.20728L50.9971 14.2834C51.2443 14.4263 51.3963 14.6903 51.3965 14.9758V41.1292C51.3963 41.4147 51.2443 41.6786 50.9971 41.8215L28.3477 54.8977C28.1002 55.0405 27.7953 55.0406 27.5479 54.8977L4.89941 41.8215C4.65201 41.6787 4.49916 41.4148 4.49902 41.1292V14.9758C4.49919 14.6902 4.65203 14.4263 4.89941 14.2834L27.5479 1.20728Z"
          stroke="#CBD5E0"
          stroke-width="1.6"
        />
        <path
          opacity="0.06"
          d="M14.1074 8.14294L27.1475 0.614262C27.6425 0.328449 28.2524 0.328449 28.7475 0.614261L51.3962 13.6905C51.8912 13.9763 52.1962 14.5045 52.1962 15.0761V41.2286C52.1962 41.8002 51.8912 42.3284 51.3962 42.6143L40.1573 49.103C27.0408 40.8036 18.7345 23.3974 14.1074 8.14294Z"
          fill="#E2E8F0"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.5983 -0.438317C27.4337 -0.920626 28.4629 -0.920626 29.2983 -0.438318L51.947 12.6379C52.7824 13.1202 53.297 14.0116 53.297 14.9762V41.1287C53.297 42.0933 52.7824 42.9846 51.947 43.4669L29.2983 56.5432C28.4629 57.0255 27.4337 57.0255 26.5983 56.5432L3.94961 43.4669C3.11423 42.9846 2.59961 42.0933 2.59961 41.1287V14.9762C2.59961 14.0116 3.11423 13.1202 3.94961 12.6379L26.5983 -0.438317ZM28.1983 1.46694C28.0436 1.37762 27.853 1.37762 27.6983 1.46694L5.04961 14.5432C4.89491 14.6325 4.79961 14.7976 4.79961 14.9762V41.1287C4.79961 41.3073 4.89491 41.4724 5.04961 41.5617L27.6983 54.6379C27.853 54.7272 28.0436 54.7272 28.1983 54.6379L50.847 41.5617C51.0017 41.4724 51.097 41.3073 51.097 41.1287V14.9762C51.097 14.7976 51.0017 14.6325 50.847 14.5432L28.1983 1.46694Z"
          fill="#4532AD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.5983 -0.438317C27.4337 -0.920626 28.4629 -0.920626 29.2983 -0.438318L51.947 12.6379C52.7824 13.1202 53.297 14.0116 53.297 14.9762V41.1287C53.297 42.0933 52.7824 42.9846 51.947 43.4669L29.2983 56.5432C28.4629 57.0255 27.4337 57.0255 26.5983 56.5432L3.94961 43.4669C3.11423 42.9846 2.59961 42.0933 2.59961 41.1287V14.9762C2.59961 14.0116 3.11423 13.1202 3.94961 12.6379L26.5983 -0.438317ZM28.1983 1.46694C28.0436 1.37762 27.853 1.37762 27.6983 1.46694L5.04961 14.5432C4.89491 14.6325 4.79961 14.7976 4.79961 14.9762V41.1287C4.79961 41.3073 4.89491 41.4724 5.04961 41.5617L27.6983 54.6379C27.853 54.7272 28.0436 54.7272 28.1983 54.6379L50.847 41.5617C51.0017 41.4724 51.097 41.3073 51.097 41.1287V14.9762C51.097 14.7976 51.0017 14.6325 50.847 14.5432L28.1983 1.46694Z"
          fill="url(#paint1_linear_2705_32564)"
        />
        <path
          d="M38.7535 33.3397C41.0534 31.0861 43.3842 28.3848 43.3842 24.85C43.3842 22.5984 42.4898 20.439 40.8976 18.8469C39.3055 17.2548 37.1461 16.3604 34.8945 16.3604C32.1778 16.3604 30.2638 17.1321 27.9485 19.4475C25.6331 17.1321 23.7191 16.3604 21.0024 16.3604C18.7508 16.3604 16.5914 17.2548 14.9993 18.8469C13.4071 20.439 12.5127 22.5984 12.5127 24.85C12.5127 28.4002 14.8281 31.1015 17.1434 33.3397L27.9485 44.1447L38.7535 33.3397Z"
          fill="#D2BE8F"
        />
        <path
          d="M38.7535 33.3397C41.0534 31.0861 43.3842 28.3848 43.3842 24.85C43.3842 22.5984 42.4898 20.439 40.8976 18.8469C39.3055 17.2548 37.1461 16.3604 34.8945 16.3604C32.1778 16.3604 30.2638 17.1321 27.9485 19.4475C25.6331 17.1321 23.7191 16.3604 21.0024 16.3604C18.7508 16.3604 16.5914 17.2548 14.9993 18.8469C13.4071 20.439 12.5127 22.5984 12.5127 24.85C12.5127 28.4002 14.8281 31.1015 17.1434 33.3397L27.9485 44.1447L38.7535 33.3397Z"
          fill="#CBD5E0"
        />
        <path
          d="M27.9485 19.4475L23.3795 24.0165C23.0658 24.3278 22.8169 24.6982 22.6471 25.1061C22.4772 25.5141 22.3898 25.9517 22.3898 26.3936C22.3898 26.8355 22.4772 27.2731 22.6471 27.681C22.8169 28.089 23.0658 28.4594 23.3795 28.7707C24.6452 30.0364 26.6673 30.0827 28.0102 28.8787L31.2054 25.946C32.0063 25.2192 33.049 24.8167 34.1305 24.8167C35.2119 24.8167 36.2547 25.2192 37.0555 25.946L41.6245 30.0519"
          fill="#D2BE8F"
        />
        <path
          d="M27.9485 19.4475L23.3795 24.0165C23.0658 24.3278 22.8169 24.6982 22.6471 25.1061C22.4772 25.5141 22.3898 25.9517 22.3898 26.3936C22.3898 26.8355 22.4772 27.2731 22.6471 27.681C22.8169 28.089 23.0658 28.4594 23.3795 28.7707C24.6452 30.0364 26.6673 30.0827 28.0102 28.8787L31.2054 25.946C32.0063 25.2192 33.049 24.8167 34.1305 24.8167C35.2119 24.8167 36.2547 25.2192 37.0555 25.946L41.6245 30.0519"
          fill="#CBD5E0"
        />
        <path d="M37.2099 34.8833L34.1228 31.7961L37.2099 34.8833Z" fill="#D2BE8F" />
        <path d="M37.2099 34.8833L34.1228 31.7961L37.2099 34.8833Z" fill="#CBD5E0" />
        <path d="M32.5792 39.514L29.492 36.4268L32.5792 39.514Z" fill="#D2BE8F" />
        <path d="M32.5792 39.514L29.492 36.4268L32.5792 39.514Z" fill="#CBD5E0" />
        <path
          d="M34.9453 15.0601C37.56 15.0601 40.0677 16.0916 41.917 17.9272C43.7664 19.763 44.8057 22.2532 44.8057 24.8501C44.8056 27.1124 43.981 29.0484 42.8564 30.7046L42.8555 30.7036C42.8238 30.7577 42.7881 30.8098 42.748 30.8599C41.8436 32.1566 40.7594 33.285 39.752 34.2651L33.5381 40.4331L33.5371 40.4341L28.8721 45.064C28.3613 45.571 27.5342 45.571 27.0234 45.064L16.1475 34.2681C13.8094 32.0236 11.0899 28.9858 11.0898 24.8501C11.0898 22.2533 12.1292 19.763 13.9785 17.9272C15.8277 16.0916 18.3356 15.0602 20.9502 15.0601C22.4495 15.0601 23.8033 15.2727 25.123 15.8433C26.1068 16.2686 27.0252 16.8748 27.9473 17.6704C28.8697 16.8744 29.7893 16.2687 30.7734 15.8433C32.0931 15.2727 33.4462 15.0601 34.9453 15.0601ZM20.9502 17.6606C19.0286 17.6607 17.1855 18.4177 15.8271 19.7661C14.4687 21.1146 13.7061 22.9438 13.7061 24.8501C13.7061 27.8105 15.6464 30.1735 17.9717 32.4048C17.9768 32.4097 17.9822 32.4144 17.9873 32.4194L27.9473 42.3062L30.7617 39.5132L28.5781 37.3462C28.0671 36.8385 28.0671 36.015 28.5781 35.5073C29.0889 35.0003 29.917 35.0003 30.4277 35.5073L32.6123 37.6753L35.4268 34.8823L33.2432 32.7153C32.7321 32.2076 32.732 31.3842 33.2432 30.8765C33.7539 30.3695 34.582 30.3695 35.0928 30.8765L37.2773 33.0454L37.9082 32.4194H37.9092L37.918 32.4106C38.65 31.6987 39.3461 30.9733 39.958 30.2212L36.249 26.9136L36.248 26.9126L36.2441 26.9097V26.9087C35.6781 26.3989 34.9406 26.1167 34.1758 26.1167C33.5072 26.1167 32.8596 26.3322 32.3291 26.7271L32.1094 26.9077H32.1074L28.8945 29.8364C28.8908 29.8398 28.8867 29.8437 28.8828 29.8472C27.0207 31.5043 24.1952 31.4507 22.4219 29.6919V29.6909C21.9846 29.2594 21.6375 28.7464 21.4004 28.1812C21.1628 27.6147 21.04 27.0067 21.04 26.3931C21.0401 25.7796 21.1629 25.1722 21.4004 24.606C21.6377 24.0403 21.9852 23.527 22.4229 23.0952L22.4238 23.0933L26.0576 19.4858C25.3594 18.9054 24.7167 18.5037 24.0791 18.228C23.1675 17.8339 22.1877 17.6606 20.9502 17.6606ZM34.9453 17.6606C33.708 17.6607 32.7289 17.834 31.8174 18.228C30.8974 18.6258 29.9637 19.2831 28.8721 20.3667L24.2695 24.936L24.2666 24.939V24.9399C24.0733 25.1305 23.9191 25.3565 23.8145 25.606C23.7098 25.8554 23.6563 26.123 23.6562 26.3931C23.6562 26.6633 23.7098 26.9316 23.8145 27.1812C23.9191 27.4306 24.0733 27.6566 24.2666 27.8472V27.8481L24.2695 27.8511L24.4209 27.9868C25.2001 28.6228 26.3438 28.6133 27.1338 27.9136L30.3447 24.9878L30.3457 24.9868L30.3506 24.9829L30.5508 24.811C31.5689 23.9761 32.8501 23.5161 34.1758 23.5161C35.5888 23.5161 36.9518 24.0386 37.999 24.981L38 24.9819L41.4072 28.021C41.897 27.0315 42.1894 25.985 42.1895 24.8501C42.1895 22.9438 41.4268 21.1146 40.0684 19.7661C38.7099 18.4178 36.867 17.6606 34.9453 17.6606Z"
          fill="#4532AD"
        />
        <path
          d="M34.9453 15.0601C37.56 15.0601 40.0677 16.0916 41.917 17.9272C43.7664 19.763 44.8057 22.2532 44.8057 24.8501C44.8056 27.1124 43.981 29.0484 42.8564 30.7046L42.8555 30.7036C42.8238 30.7577 42.7881 30.8098 42.748 30.8599C41.8436 32.1566 40.7594 33.285 39.752 34.2651L33.5381 40.4331L33.5371 40.4341L28.8721 45.064C28.3613 45.571 27.5342 45.571 27.0234 45.064L16.1475 34.2681C13.8094 32.0236 11.0899 28.9858 11.0898 24.8501C11.0898 22.2533 12.1292 19.763 13.9785 17.9272C15.8277 16.0916 18.3356 15.0602 20.9502 15.0601C22.4495 15.0601 23.8033 15.2727 25.123 15.8433C26.1068 16.2686 27.0252 16.8748 27.9473 17.6704C28.8697 16.8744 29.7893 16.2687 30.7734 15.8433C32.0931 15.2727 33.4462 15.0601 34.9453 15.0601ZM20.9502 17.6606C19.0286 17.6607 17.1855 18.4177 15.8271 19.7661C14.4687 21.1146 13.7061 22.9438 13.7061 24.8501C13.7061 27.8105 15.6464 30.1735 17.9717 32.4048C17.9768 32.4097 17.9822 32.4144 17.9873 32.4194L27.9473 42.3062L30.7617 39.5132L28.5781 37.3462C28.0671 36.8385 28.0671 36.015 28.5781 35.5073C29.0889 35.0003 29.917 35.0003 30.4277 35.5073L32.6123 37.6753L35.4268 34.8823L33.2432 32.7153C32.7321 32.2076 32.732 31.3842 33.2432 30.8765C33.7539 30.3695 34.582 30.3695 35.0928 30.8765L37.2773 33.0454L37.9082 32.4194H37.9092L37.918 32.4106C38.65 31.6987 39.3461 30.9733 39.958 30.2212L36.249 26.9136L36.248 26.9126L36.2441 26.9097V26.9087C35.6781 26.3989 34.9406 26.1167 34.1758 26.1167C33.5072 26.1167 32.8596 26.3322 32.3291 26.7271L32.1094 26.9077H32.1074L28.8945 29.8364C28.8908 29.8398 28.8867 29.8437 28.8828 29.8472C27.0207 31.5043 24.1952 31.4507 22.4219 29.6919V29.6909C21.9846 29.2594 21.6375 28.7464 21.4004 28.1812C21.1628 27.6147 21.04 27.0067 21.04 26.3931C21.0401 25.7796 21.1629 25.1722 21.4004 24.606C21.6377 24.0403 21.9852 23.527 22.4229 23.0952L22.4238 23.0933L26.0576 19.4858C25.3594 18.9054 24.7167 18.5037 24.0791 18.228C23.1675 17.8339 22.1877 17.6606 20.9502 17.6606ZM34.9453 17.6606C33.708 17.6607 32.7289 17.834 31.8174 18.228C30.8974 18.6258 29.9637 19.2831 28.8721 20.3667L24.2695 24.936L24.2666 24.939V24.9399C24.0733 25.1305 23.9191 25.3565 23.8145 25.606C23.7098 25.8554 23.6563 26.123 23.6562 26.3931C23.6562 26.6633 23.7098 26.9316 23.8145 27.1812C23.9191 27.4306 24.0733 27.6566 24.2666 27.8472V27.8481L24.2695 27.8511L24.4209 27.9868C25.2001 28.6228 26.3438 28.6133 27.1338 27.9136L30.3447 24.9878L30.3457 24.9868L30.3506 24.9829L30.5508 24.811C31.5689 23.9761 32.8501 23.5161 34.1758 23.5161C35.5888 23.5161 36.9518 24.0386 37.999 24.981L38 24.9819L41.4072 28.021C41.897 27.0315 42.1894 25.985 42.1895 24.8501C42.1895 22.9438 41.4268 21.1146 40.0684 19.7661C38.7099 18.4178 36.867 17.6606 34.9453 17.6606Z"
          fill="url(#paint2_linear_2705_32564)"
        />
        <path
          d="M34.9453 15.0601C37.56 15.0601 40.0677 16.0916 41.917 17.9272C43.7664 19.763 44.8057 22.2532 44.8057 24.8501C44.8056 27.1124 43.981 29.0484 42.8564 30.7046L42.8555 30.7036C42.8238 30.7577 42.7881 30.8098 42.748 30.8599C41.8436 32.1566 40.7594 33.285 39.752 34.2651L33.5381 40.4331L33.5371 40.4341L28.8721 45.064C28.3613 45.571 27.5342 45.571 27.0234 45.064L16.1475 34.2681C13.8094 32.0236 11.0899 28.9858 11.0898 24.8501C11.0898 22.2533 12.1292 19.763 13.9785 17.9272C15.8277 16.0916 18.3356 15.0602 20.9502 15.0601C22.4495 15.0601 23.8033 15.2727 25.123 15.8433C26.1068 16.2686 27.0252 16.8748 27.9473 17.6704C28.8697 16.8744 29.7893 16.2687 30.7734 15.8433C32.0931 15.2727 33.4462 15.0601 34.9453 15.0601ZM20.9502 17.6606C19.0286 17.6607 17.1855 18.4177 15.8271 19.7661C14.4687 21.1146 13.7061 22.9438 13.7061 24.8501C13.7061 27.8105 15.6464 30.1735 17.9717 32.4048C17.9768 32.4097 17.9822 32.4144 17.9873 32.4194L27.9473 42.3062L30.7617 39.5132L28.5781 37.3462C28.0671 36.8385 28.0671 36.015 28.5781 35.5073C29.0889 35.0003 29.917 35.0003 30.4277 35.5073L32.6123 37.6753L35.4268 34.8823L33.2432 32.7153C32.7321 32.2076 32.732 31.3842 33.2432 30.8765C33.7539 30.3695 34.582 30.3695 35.0928 30.8765L37.2773 33.0454L37.9082 32.4194H37.9092L37.918 32.4106C38.65 31.6987 39.3461 30.9733 39.958 30.2212L36.249 26.9136L36.248 26.9126L36.2441 26.9097V26.9087C35.6781 26.3989 34.9406 26.1167 34.1758 26.1167C33.5072 26.1167 32.8596 26.3322 32.3291 26.7271L32.1094 26.9077H32.1074L28.8945 29.8364C28.8908 29.8398 28.8867 29.8437 28.8828 29.8472C27.0207 31.5043 24.1952 31.4507 22.4219 29.6919V29.6909C21.9846 29.2594 21.6375 28.7464 21.4004 28.1812C21.1628 27.6147 21.04 27.0067 21.04 26.3931C21.0401 25.7796 21.1629 25.1722 21.4004 24.606C21.6377 24.0403 21.9852 23.527 22.4229 23.0952L22.4238 23.0933L26.0576 19.4858C25.3594 18.9054 24.7167 18.5037 24.0791 18.228C23.1675 17.8339 22.1877 17.6606 20.9502 17.6606ZM34.9453 17.6606C33.708 17.6607 32.7289 17.834 31.8174 18.228C30.8974 18.6258 29.9637 19.2831 28.8721 20.3667L24.2695 24.936L24.2666 24.939V24.9399C24.0733 25.1305 23.9191 25.3565 23.8145 25.606C23.7098 25.8554 23.6563 26.123 23.6562 26.3931C23.6562 26.6633 23.7098 26.9316 23.8145 27.1812C23.9191 27.4306 24.0733 27.6566 24.2666 27.8472V27.8481L24.2695 27.8511L24.4209 27.9868C25.2001 28.6228 26.3438 28.6133 27.1338 27.9136L30.3447 24.9878L30.3457 24.9868L30.3506 24.9829L30.5508 24.811C31.5689 23.9761 32.8501 23.5161 34.1758 23.5161C35.5888 23.5161 36.9518 24.0386 37.999 24.981L38 24.9819L41.4072 28.021C41.897 27.0315 42.1894 25.985 42.1895 24.8501C42.1895 22.9438 41.4268 21.1146 40.0684 19.7661C38.7099 18.4178 36.867 17.6606 34.9453 17.6606Z"
          stroke="#CBD5E0"
          stroke-width="0.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2705_32564"
          x1="27.9479"
          y1="0.0525278"
          x2="27.9479"
          y2="56.0525"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7865E0" />
          <stop offset="1" stop-color="#9A8CE8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2705_32564"
          x1="8.94397"
          y1="8.22418"
          x2="36.2951"
          y2="56.2924"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4A5568" />
          <stop offset="1" stop-color="#1A202C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2705_32564"
          x1="15.4593"
          y1="19.9494"
          x2="27.8309"
          y2="47.4469"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4A5568" />
          <stop offset="1" stop-color="#1A202C" />
        </linearGradient>
        <clipPath id="clip0_2705_32564">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

interface GroupRewardsInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function GroupRewardsInfoModal({ isOpen, onClose }: GroupRewardsInfoModalProps) {
  return (
    <Modal size="2xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent padding={0} minH={'720px'}>
        <ModalHeader bg="bg.accent.inverse-muted" position="relative">
          <HStack spacing={6} gap={6} alignItems="flex-start" p={4}>
            <Box flexShrink={0}>
              <IncentiveProgramLogo style={{ width: '120px', height: '120px' }} />
            </Box>
            <VStack align="left" spacing={3}>
              <Text fontSize="lg" fontWeight="bold" color="white" mt={0}>
                <Trans>Good Effort™ Rewards program</Trans>
              </Text>
              <Text fontSize="md" fontWeight="medium" color="white" mt={0}>
                <Trans>
                  At Duke, we believe that the best results come from a strong partnership and
                  support network for participants.
                </Trans>
              </Text>
              <Text fontSize="md" fontWeight="medium" color="white" mt={0}>
                <Trans>
                  Which is why we created the Good Effort™ rewards program to say thank you to those
                  who are giving it their all so that others can succeed.
                </Trans>
              </Text>
            </VStack>
            <ModalCloseButton color="white" />
          </HStack>
        </ModalHeader>
        <ModalBody p={0} h="full">
          <Box bg="bg.canvas">
            <VStack spacing={6} gap={6} alignItems="center" px={6} py={8}>
              <Text
                fontSize="2xl"
                fontWeight="bold"
                color="fg.accent.emphasis"
                mt={0}
                textAlign="center"
              >
                <Trans>We think your support is worth rewarding</Trans>
              </Text>
              <VStack spacing={2} gap={4} alignItems="center">
                <Text fontSize="md" color="fg.accent.emphasis" textAlign="center">
                  <Trans>
                    By supporting and guiding your participants through their courses, you
                    significantly boost their chances of success.
                  </Trans>
                </Text>
                <Text fontSize="md" color="fg.accent.emphasis" textAlign="center">
                  <Trans>
                    For every effort you make, Duke will contribute funds towards a donation goal to
                    a local charity or community organisation chosen by your team.
                  </Trans>
                </Text>
              </VStack>
              <Text
                fontSize="lg"
                fontWeight="semibold"
                color="fg.accent.emphasis"
                mt={0}
                textAlign="center"
              >
                <Trans>How to earn rewards</Trans>
              </Text>
              <Box bg="bg.muted" p={4} borderRadius="md" w="full" alignItems="left">
                <VStack spacing={2} gap={4} alignItems="flex-start">
                  <HStack>
                    <Box bg="bg.accent.inverse-muted" borderRadius="md" p={2}>
                      <Target color="white" />
                    </Box>
                    <Text fontSize="md" fontWeight="bold" color="fg.accent.emphasis" mt={0}>
                      <Trans>Help them stay on track</Trans>
                    </Text>
                  </HStack>

                  <Text color="fg.accent.emphasis">
                    <Trans>
                      You'll receive points as you guide your participants through their course
                      work.{' '}
                    </Trans>
                  </Text>

                  <HStack>
                    <Box bg="brand.100" borderRadius="md" p={2}>
                      <Layers color="#4532AD" />
                    </Box>
                    <Text fontSize="sm" color="fg.accent.emphasis" mt={0}>
                      <Trans>
                        <b>5 points</b> when a student's LLN assessment is completed and recorded
                        within 24 hours of starting
                      </Trans>
                    </Text>
                  </HStack>

                  <HStack>
                    <Box bg="brand.100" borderRadius="md" p={2}>
                      <ScrollText color="#4532AD" />
                    </Box>
                    <Text fontSize="sm" color="fg.accent.emphasis" mt={0}>
                      <Trans>
                        <b>10 points</b> are awarded when a semester is completed on time or within
                        7 days of the semester end date.
                      </Trans>
                    </Text>
                  </HStack>

                  <HStack>
                    <Box bg="brand.100" borderRadius="md" p={2}>
                      <ScrollText color="#4532AD" />
                    </Box>
                    <Text fontSize="sm" color="fg.accent.emphasis" mt={0}>
                      <Trans>
                        <b>5 points</b> are awarded when a semester is completed more than 7 days
                        after the semester end date.
                      </Trans>
                    </Text>
                  </HStack>
                </VStack>
              </Box>
            </VStack>
          </Box>
          <Box bg="brand.100" p={0}>
            <VStack spacing={6} gap={6} alignItems="center" px={6} py={4}>
              <Text
                fontSize="2xl"
                fontWeight="bold"
                color="fg.accent.emphasis"
                mt={0}
                textAlign="center"
              >
                <Trans>Stay consistent and persistent</Trans>
              </Text>
              <VStack spacing={2} gap={4} alignItems="center">
                <Text fontSize="md" color="fg.accent.emphasis" textAlign="center">
                  <Trans>
                    Some participants need an extra push, some just need a little nudge, but we
                    believe everyone can benefit from support and accountability.
                  </Trans>
                </Text>
                <Text fontSize="md" color="fg.accent.emphasis" textAlign="center">
                  <Trans>
                    This is why we reward you for being consistent and persistent with your
                    communication and check-ins. The longer you keep it up, the more rewarding Leg
                    Up™ can be for you and your participants.
                  </Trans>
                </Text>

                <HStack spacing={4} align="center" w="full" mt={2}>
                  <Box bg="bg.muted" p={4} borderRadius="md" w="350px" flexShrink={0}>
                    <HStack alignItems="center">
                      <SilverTierLogo style={{ width: '36px', height: '36px' }} />
                      <VStack align="left" spacing={0} gap={0}>
                        <Text
                          fontSize="md"
                          fontWeight="bold"
                          color="fg.accent.emphasis"
                          lineHeight="shorter"
                        >
                          <Trans>Silver Partner</Trans>
                        </Text>
                        <Text color="fg.accent.emphasis" fontSize="sm" mt={-1}>
                          <Trans>Starting to hit your monitoring goals</Trans>
                        </Text>
                      </VStack>
                    </HStack>
                  </Box>
                  <Text fontSize="xs" color="fg.accent.emphasis" lineHeight="5">
                    <Trans>
                      As you're getting started, you'll have the ability to earn all available
                      rewards for each enrolment. Consistency will see you level up.
                    </Trans>
                  </Text>
                </HStack>

                <HStack spacing={4} align="center" w="full">
                  <Box bg="bg.muted" p={4} borderRadius="md" w="350px" flexShrink={0}>
                    <HStack alignItems="center">
                      <PlatinumTierLogo style={{ width: '36px', height: '36px' }} />
                      <VStack align="left" spacing={0} gap={0}>
                        <Text
                          fontSize="md"
                          fontWeight="bold"
                          color="fg.accent.emphasis"
                          lineHeight="shorter"
                        >
                          <Trans>Platinum Partner</Trans>
                        </Text>
                        <Text color="fg.accent.emphasis" fontSize="sm" mt={-1}>
                          <Trans>4+ weeks of hitting monitoring goals</Trans>
                        </Text>
                      </VStack>
                    </HStack>
                  </Box>
                  <Text fontSize="xs" color="fg.accent.emphasis" lineHeight="5">
                    <Trans>
                      Hit your goals for over a month, you'll become a Platinum partner, earning an
                      extra 5% on rewards for each enrolment
                    </Trans>
                  </Text>
                </HStack>
              </VStack>
            </VStack>
          </Box>
        </ModalBody>
        <ModalFooter bg="bg.accent.inverse-muted" position="relative">
          <Box w="full" textAlign="center" p={6}>
            <Text
              fontSize="lg"
              fontWeight="semibold"
              color="white"
              mt={0}
              textAlign="center"
              maxW="400px"
              mx="auto"
            >
              <Trans>
                Duke has partnered with organisations to support great causes all over Australia
              </Trans>
            </Text>
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
